export enum HandlerModeTypeEnum {
  All = 'All',
  Admin = 'Admin',
}

